export default "__VITE_ASSET__jzpDGLqu__"